import request from '@/utils/request'
// 查询消息列表
export function getNotification(params) {
  return request({
    url: `/api/v2/notification`,
    method: 'get',
    params
  })
}
// 获取消息通知详情接口 获取详情之后会从未读变为已读
export function getNotificationId(notificationId) {
  return request({
    url: `/api/v2/notification/${notificationId}`,
    method: 'get'
  })
}

// 根据类型批量已读
export function putNotificationTypeIsRead(params) {
  return request({
    url: `/api/v2/notification/type/isRead?type=${params.type}&userId=${params.userId}`,
    method: 'put'
  })
}
// 批量删除
export function delNotification(data) {
  return request({
    url: `/api/v2/notification/batch`,
    method: 'DELETE',
    data
  })
}

// 全部已读
export function putNotificationIsRead() {
  return request({
    url: `/api/v2/notification/isRead?isApp=false`,
    method: 'put'
  })
}
